import * as styles from "./Collapsible.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Collapsible as BaseCollapsible } from "@base-ui/react/collapsible";

import {
  CollapsibleContext,
  makeCollapsibleContext,
} from "./Collapsible.context";
import type { CollapsibleProps } from "./Collapsible.types";

export function Collapsible({
  size,
  variant,
  className,
  ...props
}: CollapsibleProps): JSX.Element {
  return (
    <CollapsibleContext.Provider
      value={makeCollapsibleContext({ size, variant })}
    >
      <BaseCollapsible.Root
        data-slot="collapsible"
        className={clsx(styles.root, className)}
        {...props}
      />
    </CollapsibleContext.Provider>
  );
}
